module.exports = __webpack_public_path__ + "static/media/search.944e910d.svg";